import React from 'react';
import PropTypes from 'prop-types';
import stateReducer from './multiselectReducer';
import SelectedItemList from './SelectedItemList';
import SelectBase from './SelectBase';
import { DownArrow } from './SelectInput';
import { renderSelectItems } from './SelectItem';

const multiselectReducer = stateReducer(false);

const blankStr = () => '';

const caseInsensitiveIncludes = (strA = '', strB = '') =>
    strA.toUpperCase().includes(strB.toUpperCase());

const filterOptions = ({ inputValue }) => item =>
    !inputValue || caseInsensitiveIncludes(item.label, inputValue);

const isItemSelected = (item, selectedItem) =>
    selectedItem && selectedItem.some(selected => selected.value === item.value);

const renderOptions = renderSelectItems(isItemSelected);

const renderInputDecoration = disabled => () => <DownArrow disabled={disabled} />;

const MultipleSelect = ({ initialValue, disabled, onBlur, ...rest }) => {
    return (
        <SelectBase
            stateReducer={multiselectReducer}
            initialValue={initialValue || []}
            selectedItemToString={blankStr}
            noResultsText="No results found"
            disabled={disabled}
            onBlur={onBlur}
            filterOptions={filterOptions}
            renderOption={renderOptions}
            renderInputDecoration={renderInputDecoration(disabled)}
            renderSelected={SelectedItemList}
            {...rest}
        />
    );
};

MultipleSelect.propTypes = {
    placeholder: PropTypes.string,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            label: PropTypes.string
        })
    ).isRequired,
    initialValue: PropTypes.array,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    size: PropTypes.string //Controls width of field
};

export default MultipleSelect;
